import { ProficiencyLevelEnum } from '@sport-activities/sdk';

import { SportGroup } from './attendee/interfaces/sport-group.interface';
import { AudiencesEnum } from './organizer/activity-creation/components/pages/audience/enums/audiences.enum';

export const appConfig = {
  filters: {
    defaultDistance: 20,
    // our sports groups mapped to data api sport groups
    sportGroups: {
      exercise: {
        title: 'sports.exercise.title',
        description: 'sports.exercise.description',
        image: 'assets/sports/sport-filter/multisports.png',
        idCollection: [
          1, 2, 6, 27, 31, 57, 69, 89, 110, 119, 203, 204, 205, 206, 207, 208,
          209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222,
          224, 229, 243, 244,
        ],
      },
      wellness: {
        title: 'sports.wellness.title',
        description: 'sports.wellness.description',
        image: 'assets/sports/sport-filter/wellness.png',
        idCollection: [140, 178, 201],
      },
      run_walk: {
        title: 'sports.run_walk.title',
        description: 'sports.run_walk.description',
        image: 'assets/sports/sport-filter/run-and-walk.png',
        idCollection: [
          8, 21, 51, 53, 64, 65, 115, 150, 186, 232, 187, 237, 240,
        ],
      },
      cycling_skating: {
        title: 'sports.cycling_skating.title',
        description: 'sports.cycling_skating.description',
        image: 'assets/sports/sport-filter/cycling-skating.png',
        idCollection: [
          14, 16, 18, 28, 42, 72, 73, 93, 117, 127, 151, 152, 161, 187, 188,
          190, 191, 192, 193, 228, 237, 239, 240, 242,
        ],
      },
      outdoor: {
        title: 'sports.outdoor.title',
        description: 'sports.outdoor.description',
        image: 'assets/sports/sport-filter/outdoor.png',
        idCollection: [23, 25, 30, 77, 79, 126, 164, 165, 169, 170, 150, 186],
      },
      water_sports: {
        title: 'sports.water_sports.title',
        description: 'sports.water_sports.description',
        image: 'assets/sports/sport-filter/water.png',
        idCollection: [
          5, 17, 20, 26, 34, 39, 54, 55, 91, 95, 105, 120, 121, 141, 148, 166,
          176, 194, 196, 197, 198, 199, 200, 239,
        ],
      },
      sport_team: {
        title: 'sports.sport_team.title',
        description: 'sports.sport_team.description',
        image: 'assets/sports/sport-filter/teamsports.png',
        idCollection: [3, 37, 38, 82, 83, 84, 90, 92, 94, 154, 195, 226],
      },
      racket_sports: {
        title: 'sports.racket_sports.title',
        description: 'sports.racket_sports.description',
        image: 'assets/sports/sport-filter/raquets.png',
        idCollection: [10, 35, 40, 70, 123, 134, 147, 174, 180, 181],
      },
      precision: {
        title: 'sports.precision.title',
        description: 'sports.precision.description',
        image: 'assets/sports/sport-filter/precision.png',
        idCollection: [
          11, 19, 41, 43, 45, 47, 48, 81, 87, 96, 124, 137, 182, 183, 184,
        ],
      },
      combat: {
        title: 'sports.combat.title',
        description: 'sports.combat.description',
        image: 'assets/sports/sport-filter/combat.png',
        idCollection: [
          7, 12, 29, 32, 49, 50, 56, 80, 97, 98, 99, 100, 102, 103, 104, 106,
          107, 108, 159, 177,
        ],
      },
    } as { [key: string]: SportGroup },
  },
  pagination: {
    timeslot: {
      loadMore: 20,
    },
    loadMore: {
      mobile: 24,
      desktop: 24,
    },
    result: 24,
  },
  defaultImage: 'https://dpp1zxb4fj9eb.cloudfront.net/sports/292.jpg',
  pixl: {
    url: 'https://contents.mediadecathlon.com',
  },
  component: {
    form: {
      address: {
        searchMinimumCharacters: 3,
      },
    },
  },
  formValidationRules: {
    activityDescriptionMinimumLength: 150,
    activityTitleMaximumLength: 50,
    activityProficiencyLevels: [
      {
        labelKey: 'activity_creation.audience.level.beginner.label',
        key: 5 as ProficiencyLevelEnum,
      },
      {
        labelKey: 'activity_creation.audience.level.confirmed.label',
        key: 10 as ProficiencyLevelEnum,
      },
      {
        labelKey: 'activity_creation.audience.level.expert.label',
        key: 20 as ProficiencyLevelEnum,
      },
    ],
    activityMaxAgeInputMax: 100,
    activityMaxAgeInputMin: 0,
    activityMinAgeInputMax: 100,
    activityMinAgeInputMin: 0,
    activityAudience: [
      {
        textKey: 'activity_creation.audience.audience.adults.text',
        value: AudiencesEnum.Adults,
      },
      {
        textKey: 'activity_creation.audience.audience.children.text',
        value: AudiencesEnum.Children,
      },
      {
        textKey: 'activity_creation.audience.audience.custom.text',
        value: AudiencesEnum.Custom,
      },
    ],
    activityAddressDescriptionMaximumLength: 150,
    organizerDescriptionMinimumLength: 150,
    organizerFEDDescriptionMinimumLength: 200,
    paymentPromoCodeMinimumLength: 5,
    paymentPromoCodeMaximumLength: 12,
  },
  numberOfTimeslotsToDisplay: 4,
  levValue: 1.95583,
  apiMaxLimit: 10000,
  // Configure the refund time limit by activity type with ISO duration.
  refundLimit: { BIRTHDAY: 'P15D' },
};
